import { render, staticRenderFns } from "./DocumentInstitution.vue?vue&type=template&id=301364cd"
import script from "./DocumentInstitution.vue?vue&type=script&lang=js"
export * from "./DocumentInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports